import React from "react";

const TaskCalendar = ({
  role,
  currentDate,
  userTasks,
  allTasks,
  selectedEmployee,
  selectedDate,
  onDateClick,
}) => {
  const formatDateForAPI = (year, month, day) => {
    const mm = String(month + 1).padStart(2, "0");
    const dd = String(day).padStart(2, "0");
    return `${year}-${mm}-${dd}`;
  };

  const daysInMonth = (date) =>
    new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();

  const firstDayOfMonth = (date) =>
    new Date(date.getFullYear(), date.getMonth(), 1).getDay();

  const today = new Date();
  today.setHours(0, 0, 0, 0); 
  const todayKey = formatDateForAPI(today.getFullYear(), today.getMonth(), today.getDate());

  const isFutureDate = (dateKey) => {
    const date = new Date(dateKey);
    date.setHours(0, 0, 0, 0);
    return date > today;
  };

  const isDateOnLeave = (dateKey) => {
    const tasksForDate = role === "employee" 
      ? userTasks?.filter((t) => t.date?.startsWith(dateKey))
      : allTasks?.filter((t) => t.date?.startsWith(dateKey));
    
    return tasksForDate?.some((task) => task.leave === true);
  };

  const hasRegularTask = (dateKey) => {
    const tasksForDate = role === "employee"
      ? userTasks?.filter((t) => t.date?.startsWith(dateKey))
      : allTasks?.filter((t) => t.date?.startsWith(dateKey));
    
    return tasksForDate?.some((task) => task.leave === false || !task.leave);
  };

  const renderCalendar = () => {
    const days = [];
    const totalDays = daysInMonth(currentDate);
    const firstDay = firstDayOfMonth(currentDate);

    for (let i = 0; i < firstDay; i++) {
      days.push(<div key={`empty-${i}`} className="h-24"></div>);
    }

    for (let day = 1; day <= totalDays; day++) {
      const dateKey = formatDateForAPI(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        day
      );

      const isToday = dateKey === todayKey;
      const isPastDate = new Date(dateKey) < today;
      const isFuture = isFutureDate(dateKey);
      const isLeave = isDateOnLeave(dateKey);
      const hasTask = hasRegularTask(dateKey);

      let bgClass = "bg-white";
      let borderClass = "border";
      let textColor = "text-gray-900";
      let cursorClass = "cursor-pointer hover:bg-indigo-50";
      let opacityClass = "";
      
      if (isFuture) {
        bgClass = "bg-gray-100";
        textColor = "text-gray-400";
        cursorClass = "cursor-not-allowed";
        opacityClass = "opacity-60";
      } else if (isLeave) {
        bgClass = "bg-orange-100";
        textColor = "text-orange-900 font-semibold";
      } else if (isToday) {
        bgClass = "bg-[#dbeafe]";
        borderClass = "border-2 border-blue-500";
        textColor = "text-blue-900 font-semibold";
      } else if (hasTask) {
        bgClass = "bg-[#dcfce7]"; 
      } else if (isPastDate) {
        bgClass = "bg-[#fef2f2]"; 
        textColor = "text-gray-500";
      }

      days.push(
        <div
          key={day}
          onClick={() => !isFuture && onDateClick(dateKey)}
          className={`h-24 lg:h-24 2xl:h-32 flex flex-col items-center justify-center ${borderClass} ${bgClass} 
          ${cursorClass} ${opacityClass} transition relative group`}
        >
          <span className={`${textColor}`}>{day}</span>
          
          {/* Future date indicator */}
          {/* {isFuture && (
            <span className="absolute top-1 right-1 text-gray-400 text-[10px]">
              🔒
            </span>
          )} */}
          
          {/* Leave indicator badge */}
          {isLeave && !isFuture && (
            <span className="absolute top-1 right-1 bg-orange-500 text-white text-[10px] px-1.5 py-0.5 rounded-full font-semibold">
              Leave
            </span>
          )}
          
          {/* Task indicator dot - show if has regular tasks (even if also has leave) */}
          {hasTask && !isFuture && (
            <span className="absolute bottom-2 w-2 h-2 bg-green-500 rounded-full"></span>
          )}
          
          {/* Tooltip on hover */}
          {isFuture && (
            <div className="absolute bottom-full mb-2 hidden group-hover:block bg-gray-800 text-white text-xs px-2 py-1 rounded whitespace-nowrap z-10">
              Future Date - Not Available
            </div>
          )}
          
          {isLeave && !isFuture && (
            <div className="absolute bottom-full mb-2 hidden group-hover:block bg-gray-800 text-white text-xs px-2 py-1 rounded whitespace-nowrap z-10">
              On Leave
            </div>
          )}
        </div>
      );
    }

    return days;
  };

  return (
    <>
      <div className="grid grid-cols-7 bg-gray-100 border-b border-gray-300">
        {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((day) => (
          <div key={day} className="p-4 text-center font-semibold text-gray-700">
            {day}
          </div>
        ))}
      </div>
      <div className="grid grid-cols-7">{renderCalendar()}</div>
    </>
  );
};

export default TaskCalendar;